(async () => {
  if (!customElements.get('highlighted-product-card')) {
    const { default: Swiper, A11y, Navigation } = await import('swiper');

    Swiper.use([A11y, Navigation]);

    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.createSwiper();
      }

      createSwiper() {
        this.swiperElement = this.querySelector('[data-product-card-swiper]');
        this.swiperOptions = {
          watchOverflow: true,
          preventClicks: true,
          loop: false,
          autoplay: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
          },
          slidesPerView: 1,
          direction: 'horizontal',
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }
    }

    window.ProductCard = ProductCard;

    customElements.define('highlighted-product-card', ProductCard);
  }
})();
